exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info.legend span{display:block}.gradient{width:95%;margin:0 auto;white-space:nowrap;position:relative;top:6px;padding-bottom:15px}.grad-step{display:inline-block;height:20px;width:1%}.gradient .domain-min{position:absolute;left:0;font-size:11px;bottom:3px}.gradient .domain-med{position:absolute;right:25%;left:25%;text-align:center;font-size:11px;bottom:3px}.gradient .domain-max{position:absolute;right:0;font-size:11px;bottom:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2cd0145d","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ReferenceChart.vue
// module id = 15
// module chunks = 0